<template>
  <div class="content">
    <loading
      name="lp"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="card mb-4">
        <div class="card-header">
          <div class="row">
            <div class="col-lg-3 col-sm-12">
              <base-button outline type="primary" block @click="onBack()">
                <span class="btn-inner--icon">
                  <i class="ni sign-left"></i>
                </span>
                Back to main page</base-button
              >
            </div>
          </div>
        </div>

        <div class="row card-body">
            <div class="col-lg-4 mb-2">
              <el-select
                class="select-primary pagination-select"
                v-model="filter"
                placeholder="Class"
                style="width: 100%"
              >
                <el-option
                  class="select-primary"
                  :key="1"
                  label="Actual"
                  :value="1"
                ></el-option>
                <el-option
                  class="select-primary"
                  :key="2"
                  label="All"
                  :value="2"
                ></el-option>
              </el-select>
            </div>
     <div style="margin-left: 15px">
          <masonry
            :cols="{ default: 3, 1000: 2, 500: 1 }"
            :gutter="{ default: '30px', 700: '15px' }"
          >
            <div v-for="item in hws.filter(c => ((c.status !== 3 || isactual(c.publish)) && filter === 1) || (filter === 2))" :key="item.id">
              <homework-item :item="item"></homework-item>
            </div>
          </masonry>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import HomeworkItem from "./HomeworkItem";
import { GetHomeworkByStudent } from "../../../services/homework";
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    Loading,
    HomeworkItem,
  },
  data() {
    return {
      isLoading: false,
      hws: [],
      filter: 1,
    };
  },
  methods: {
    onBack() {
      this.$router.push({ name: "StudentMain" }).catch((e) => {});
    },
    loadTasks() {
      GetHomeworkByStudent(this.$store.state.user.id).then((response) => {
        if (response.data.result) {
          this.hws = response.data.result;
        }
      });
    },
    isactual(dt) {
      let d = new Date(dt);
      let n = new Date();
      if (parseInt((d - n) / (24 * 3600 * 1000)) > 7) return false;
      else return true;
    },
  },
  mounted() {
    this.loadTasks();
  },
};
</script>

<style lang="scss" scoped>
</style>